var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useParams } from "react-router-dom";
import { ContextMenuAFY, icons, sizesIcon, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
export var ColumnsPaymentRecurrence = function () {
    var idProduct = useParams().idProduct;
    var isEdit = useParams().isEdit;
    return [
        {
            field: "actions",
            headerName: "",
            width: 80,
            renderCell: function (params) { return (_jsx("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: (!idProduct || (idProduct && isEdit === "true")) && (_jsx(ContextMenuAFY, { colorButton: "#fff", iconButton: icons.MoreVert, iconColor: "#3A56A1", menuItem: [
                        {
                            disabled: false,
                            icon: {
                                color: "#006ac6",
                                icon: icons.DeleteForever,
                                size: sizesIcon.standard,
                            },
                            id: "1",
                            name: "Eliminar",
                        },
                    ], 
                    // onClickContextMenu={(item: any) =>
                    //   // handleClickContextMenu(item, params)
                    // }
                    sizeIcon: sizesIcon.standard })) }))); },
        },
        {
            editable: true,
            field: "code",
            flex: 1,
            headerName: "Código",
            width: 150,
        },
        {
            field: "description",
            flex: 1,
            headerName: "Descripción",
            width: 160,
        },
    ];
};
export var ColumnsPaymentMode = function () {
    var idProduct = useParams().idProduct;
    var isEdit = useParams().isEdit;
    return [
        {
            field: "actions",
            headerName: "",
            width: 80,
            renderCell: function (params) { return (_jsx("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: (!idProduct || (idProduct && isEdit === "true")) && (_jsx(ContextMenuAFY, { colorButton: "#fff", iconButton: icons.MoreVert, iconColor: "#3A56A1", menuItem: [
                        {
                            disabled: false,
                            icon: {
                                color: "#006ac6",
                                icon: icons.DeleteForever,
                                size: sizesIcon.standard,
                            },
                            id: "1",
                            name: "Eliminar",
                        },
                    ], 
                    // onClickContextMenu={(item: any) =>
                    //   // handleClickContextMenu(item, params)
                    // }
                    sizeIcon: sizesIcon.standard })) }))); },
        },
        {
            editable: true,
            field: "code",
            flex: 1,
            headerName: "Código",
            width: 150,
        },
        {
            field: "description",
            flex: 1,
            headerName: "Descripción",
            width: 160,
        },
    ];
};
export var dataProductCreationForm = {
    IdSponsor: "",
    IdTypeInsurance: "",
    Description: "",
    Code: "",
    IdCurrency: "",
    CertifyNumber: "",
    QuotesNumber: 0,
    PolicyNumber: 0,
};
export var dataForm = {
    Name: "",
    Code: "",
};
